import { render, staticRenderFns } from "./customer-addresses.vue?vue&type=template&id=72539cea&"
import script from "./customer-addresses.vue?vue&type=script&lang=js&"
export * from "./customer-addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports